/* eslint-disable class-methods-use-this */
import _axios, { put, _delete } from '@/utils/axios'
class Participant {
    /**
     * 获取列表
     */

    // 类中的方法可以代表一个用户行为
    async getAll() {
        console.log('进入getall')
        const res = await _axios.get(`user/getAll`)
        return res
    }



    async put(data) {
        if (!data.id) {
            return
        }
        return put(`cms/order/${data.id}`, data)
    }



    async create(data) {
        return _axios({
            method: 'post',
            url: 'user',
            data,
        })
    }

    async deleteAll() {
        return _axios({
            method: 'delete',
            url: 'participant',
        })
    }


    // 删除
    async _delete(id) {
        return _delete(`user?id=${id}`)
    }





}

export default new Participant()
